import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractEmailList'

function* fetchContractEmailListsRefresh({ contractID, size, index, searchTerm, orderBy }) {
  console.log('fetchContractEmailListsRefresh', contractID, size, index, searchTerm, orderBy)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, contractID, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_CONTRACTEMAILLIST,
    result,
  })
}

function* fetchContractEmailLists({ contractID, size, index, searchTerm, orderBy }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, contractID, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_CONTRACTEMAILLIST,
    result,
  })
}

function* fetchContractEmailListEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  console.log('fetchContractEmailListEdit result', result)
  yield put({
    type: actions.EDIT_CONTRACTEMAILLIST,
    result,
  })
}

function* fetchContractEmailListSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_CONTRACTEMAILLIST_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CONTRACTEMAILLISTS,
  })
}

function* fetchContractEmailListDelete(values) {
  console.log('fetchContractEmailListDelete values', values)
  const contractID = values.values.contractID
  console.log('fetchContractEmailListDelete contractID', contractID)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_CONTRACTEMAILLIST_RECIEVED,
    result,
  })
  console.log('fetchContractEmailListDelete contractID', contractID)
  yield put({
    type: actions.RE_FETCH_CONTRACTEMAILLISTS,
    contractID,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTEMAILLISTS, fetchContractEmailLists),
    takeEvery(actions.FETCH_CONTRACTEMAILLIST, fetchContractEmailListEdit),
    takeEvery(actions.SAVE_CONTRACTEMAILLIST, fetchContractEmailListSave),
    takeEvery(actions.DELETE_CONTRACTEMAILLIST, fetchContractEmailListDelete),
    takeEvery(actions.RE_FETCH_CONTRACTEMAILLISTS, fetchContractEmailListsRefresh),
  ])
}
